import { useContext, useCallback } from 'react';
import { BannerContext } from '../contexts/BannerContext';
import usePusherAiOrderDraft from '../hooks/usePusherAiOrderDraft';
import useApplyOrderDraft from '../hooks/useApplyOrderDraft';

/**
 * Auto-applies AI chat order drafts to the active chart as soon as they're
 * generated (live Pusher event). The actual apply logic lives in
 * useApplyOrderDraft, shared with the "Add to chart" button on OrderDraftCard
 * for re-applying a draft from chat history.
 */
const AiOrderDraftListener = () => {
  const { showMessage } = useContext(BannerContext);
  const applyDraft = useApplyOrderDraft();

  const handleDraft = useCallback((draft) => {
    if (!draft) return;
    if (draft.status !== 'ok' || !draft.order) {
      // The chat reply already shows this text; only bother with a banner for
      // an outright rejection, which the user might not be looking at chat for.
      if (draft.status === 'rejected' && draft.message) showMessage(draft.message, 'warning');
      return;
    }
    applyDraft(draft);
  }, [applyDraft, showMessage]);

  usePusherAiOrderDraft(handleDraft);

  return null;
};

export default AiOrderDraftListener;
